import { holdingStatusesDataSource } from 'infrastructure/data-sources/holding-statuses';
import { HoldingStatus } from 'infrastructure/enums';
import { parseDateSafe } from 'utils/timeHelper';
import { differenceInCalendarDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

import type React from 'react';
import type { IPatientHoldingStatus } from 'infrastructure/interfaces';

interface IProps {
  status?: IPatientHoldingStatus;
}

const HoldingStatusLabel: React.FC<IProps> = ({ status }) => {
  if (!status) return '';

  const { t } = useTranslation();
  const stat = holdingStatusesDataSource().findByField('id', status.status);

  if (status.status !== HoldingStatus.Active) {
    const today = new Date();
    const endDate = parseDateSafe(status.endTime);
    const remainingDays = differenceInCalendarDays(endDate!, today);

    return `${stat?.name} ${remainingDays + 1} ${t('labels.days')}`;
  }

  return stat?.name;
};

export default HoldingStatusLabel;
